import React, { FC } from "react";

import {
  useApisMembersInsightPostsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  insightPostId: string;
  onClose: () => void;
};

export const InsightPostsLikedEmployeesModal: FC<PropsType> = ({
  insightPostId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersInsightPostsLikedEmployeesIndex({
      insightPostId,
      config: {
        onSuccess: (data) => {
          setItems(data.pages.map((page) => page.insightPostLikes).flat());
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
